export default __webpack_public_path__ + "static/media/404.857add79.png";